import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  spacing: 4, 
  components: {
        MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '4px 8px', // default is 16px
        },
        head: {
          padding: '4px 8px',
          fontWeight: 'bold',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: '32px', // default is around 56px
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          margin: '4px 0',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          padding: '0px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',  // Disable all caps
          borderRadius: '4px',    // Rounded corners
          padding: '10px 16px',   // Padding
        },
      },
      defaultProps: {
        disableElevation: true,  // Flat buttons by default
      },
    },
  },
});

export default theme;